module.exports = __webpack_public_path__ + "static/img/weimou.f776241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/weimou.jpg
// module id = bvto
// module chunks = 1